import { Pipe, PipeTransform } from '@angular/core';
import { ChartTypes } from '@mode/shared/contract-common';

/**
 * @description Custom formats don't (currently) have an entry in the
 * by-type format collections, which means we can't use the predefined
 * menu item label for custom formats; ie. formats that were configured via
 * the more formats modal. This pipe checks to see if the format is a custom type,
 * return Custom if true, falling back to the default label otherwise
 *
 * @example
 * ```html
 * {{ 'Auto' | labelOrCustom:FormatShortcutType.Custom }} // -> 'Custom'
 * {{ 'Short number' | labelOrCustom:FormatShortcutType.ShortNumber }} // -> 'Short number'
 * ```
 */
@Pipe({
  name: 'labelOrCustom',
})
/*eslint-disable-next-line @angular-eslint/use-pipe-transform-interface*/
export class LabelOrCustomPipe implements PipeTransform {
  transform(label: string, format?: ChartTypes.FormatShortcutType): string {
    return format === ChartTypes.FormatShortcutType.Custom ? 'Custom' : label;
  }
}
